import ToollBar from "./Toollbar";
import ListBoard from './ListBoard';
import { IOccurrence } from "../types";
import { SelectOption } from "@rio-cloud/rio-uikit";

interface Props {
    data: IOccurrence[];
    handleSearch: (text: string) => void;
    handleDn: (text: string) => void;
    handleResponsible: (text: string) => void;
    handleSupportType: (subject: string) => void;
    isLoading: boolean;
    optionsRegionals: SelectOption[];
    handleRegional: (subject: string) => void;
    search?: string;
    dn?: string;
    responsible?: string;
    regional?: string;
    supportType: string;
}

const SupportBoard = ({
    data, 
    handleSearch, 
    handleSupportType, 
    handleDn, 
    handleResponsible, 
    isLoading, 
    optionsRegionals, 
    handleRegional,
    search,
    dn,
    responsible,
    regional,
    supportType,
}: Props) => {
    return (
        <div>
            <ToollBar 
                handleSearch={handleSearch} 
                handleSupportType={handleSupportType} 
                handleDn={handleDn} 
                handleResponsible={handleResponsible}
                optionsRegionals={optionsRegionals}
                handleRegional={handleRegional}
                search={search}
                dn={dn}
                responsible={responsible}
                regional={regional}
                supportType={supportType}
            />
            <ListBoard data={data} isLoading={isLoading} />
        </div>
    )
}

export default SupportBoard;